import type { DocMigration } from "../docMigration";

// From systemDrawingTemplates.ts at the time of migration
const SYSTEM_DRAWING_TEMPLATE_IDS = [
  "defaultViewportTitleDrawingTemplate",
  "defaultRoomTagTemplate",
  "ceilingHeightRoomTagTemplate",
  "floorMaterialRoomTagTemplate",
  "dimensionsRoomTagTemplate",
  "areaRoomTagTemplate",
];

const migration: DocMigration = {
  id: "20260526_clear_invalid_content_template_instances",
  description: "Remove content template instances that reference non-existent content templates",
  apply(json: any, warnings: string[]) {
    const contentTemplateInstances = json.contentTemplateInstances;
    if (!contentTemplateInstances) {
      return json;
    }

    const contentTemplates = json.contentTemplates ?? {};
    for (const id in contentTemplateInstances) {
      const instance = contentTemplateInstances[id];
      const templateId = instance.contentTemplateId;
      if (!contentTemplates[templateId] && !SYSTEM_DRAWING_TEMPLATE_IDS.includes(templateId)) {
        warnings.push(`Content template instance ${id} has no corresponding content template, removed`);
        delete contentTemplateInstances[id];
      }
    }

    return json;
  },
};

export default migration;
